import API, { api_key } from './api'

export const getNativeAds = async (query) => {
    try {
        const response = await API.get('/nativeads', {
            params: {
                ...query,
            },
        })

        console.log(query)

        return response.data
    } catch (err) {
        return {
            message: 'Error in native ads api helper',
            error: err,
        }
    }
}

export const getNativeAd = async (id) => {
    try {
        const response = await API.get(`/nativeads/${id}`)

        return response.data
    } catch (err) {
        return {
            message: 'Error in nativeads api helper',
            error: err,
        }
    }
}

export const createNativeAd = async (ad) => {
    try {
        const response = await API.post(
            `/nativeads`,
            {
                title: ad.title,
                location_id: ad.location_id,
                ad: {}
            },
            {
                params: {
                    ...api_key,
                },
            }
        )

        console.log(response)

        return response.data
    } catch (err) {
        return {
            message: 'Error in categories nativeads helper',
            error: err,
        }
    }
}

export const updateNativeAd = async (ad) => {
    try {
        const response = await API.put(
            `/nativeads/${ad.id}`,
            {
                title: ad.title,
                start_date: ad.start_date,
                end_date: ad.end_date,
                status: ad.status,
                ad: ad.ad
            },
            {
                params: {
                    ...api_key,
                },
            }
        )

        return response.data
    } catch (err) {
        return {
            message: 'Error in nativeads api helper',
            error: err,
        }
    }
}

export const deleteNativeAd = async (ad) => {
    // delets ad by id
    try {
        const response = await API.delete(`/nativeads/${ad.id}`, {
            params: {
                ...api_key,
            },
        })

        return response.data
    } catch (err) {
        return {
            message: 'Error in nativeads api helper',
            error: err,
        }
    }
}
